module.exports = __webpack_public_path__ + "img/ms_azure.fa8582e6.jpg";